
<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">Notice List ======= {{ userId }}</h2>
            <!-- breadcrumbs -->
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em> HHP svc
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Notice
            </div>
            <!-- //breadcrumbs -->
            <div>
                <!-- Grid -->
                <div class="grid_wrap">
                    <div id="grid">
                        <toast-grid
                            gridId="gridNotice"
                            :key="gridKey"
                            :data="gridData"
                            :columns="gridColumns"
                            :options="gridOptions"
                            :pageOptions="gridPageOptions"
                            :theme="gridTheme"
                            :isTotalCount="false"
                            v-bind:click="onRowClick"
                        />
                    </div>
                </div>
                <div class="paginate">
                    <sdl-pagination
                        :current-page="currentPage"
                        :total-rows="resultCount"
                        :per-page="perPage"
                        @change="search"
                        align="center"
                    />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

import axios from 'axios';
import qs from 'query-string';

import { SDLUtil } from '@/utils';
import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

export default {
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
    },
    computed: {
        ...mapGetters({
            loginSystem: 'getLoginSystem',
            loginNo: 'getLoginNo',
        }),
        getEditorId() {
            return this.editorId;
        },
    },
    data() {
        return {
            resultCount: 0,
			
            //userId: 'vvvvvv',
            userId: SDLUtil.getLoginedUserInfo().loginId,
            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],
            gridColumns: [
                {
                    header: 'Subject',
                    name: 'TITLE',
                    align: 'left',
                    minWidth: 240,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Register',
                    name: 'REG_USER_ID',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: 'Registered by',
                    name: 'REG_DT',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: 'Update Date',
                    name: 'UDT_DT',
                    align: 'center',
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
        };
    },
    created() {
        this.initLoad();
        
        this.drawWatermark();
        
        setTimeout(function(){
            drawWatermark();
            $(".water-marker-ani-view").hide();
        },1500);
        
        window.onresize = function(){
            var page_width = Math.max(document.body.scrollWidth, document.body.clientWidth);
            drawWatermark();
            $(".water-marker-ani-view").hide();
        }
    },
    methods: {
        async initLoad() {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchList(this.currentPage);
            SDLUtil.showLoadingBar(false);
            if (data === false) {
                return;
            }
            this.setData(data);
        },

        fetchList(pageNo) {
            if (!pageNo) pageNo = 1;

            const formData = {
                page: pageNo,
                // searchSubsidiaries: this.getCompanyName(),
            };
            const path = '/basis/anysvcmobile/notice/noticeListSearch.skp';
            return SDLUtil.postForm(path, formData);
        },
        setData(data) {
            const { count, rows } = data;
            this.resultCount = count;
            this.setGridData(rows);
            return;
        },
        setGridData(data) {
            this.gridData = data.map(item => {
                if (item.STARTDATE && item.ENDDATE) {
                    item.DATE = `${item.STARTDATE} - ${item.ENDDATE}`;
                }
                item.STATUS = item.STATUS === 'N' ? 'Normal' : 'Important';
                return item;
            });
            this.gridKey += 1;
        },
        onGoToPage(pageNo) {
            this.goToPage(pageNo);
        },
        async goToPage(pageNo) {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchList(this.currentPage); // .then(this.setData);
            if (data === false) {
                SDLUtil.alert({
                    title: 'Server Error',
                    msg: 'Please try again.',
                });
                return;
            }
            this.setData(data);
            this.currentPage = pageNo;
            SDLUtil.showLoadingBar(false);
        },

        onRowClick(event, rowData) {
            console.log(event);
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);
            console.log('event row', rowData[event.rowKey]);
            if (event.columnName === 'TITLE') {
                this.viewContent(row.SEQ);
            }
        },

        viewContent(seq) {
            this.$router.push({ 
                path: "/basis/anysvcmobile/notice/detail",
                query: { seq: seq.toString() }, // seq: seq
            })
            //this.switchMode(MODE.VIEW);
        },

        switchMode(mode) {
            this.mode = mode;
        },

        drawWatermark() {
            $(".water-marker-ani-view").show();
            //默认设置
            var defaultSettings = {
                watermark_x: 20, //水印起始位置x轴坐标
                watermark_y: 20, //水印起始位置Y轴坐标
                watermark_rows: 200, //水印行数
                watermark_cols: 200, //水印列数
                watermark_x_space: 100, //워터마크 글자의 간격 x 
                watermark_y_space: 100, //워터마크 글자의 간격 y 
                watermark_width: 100, //水印宽度
                watermark_height: 50 //水印长度
            };
            if (arguments.length === 1 && typeof arguments[0] === "object") {
                var src = arguments[0] || {};
                for (key in src) {
                    if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key]) continue;
                    else if (src[key]) defaultSettings[key] = src[key];
                }
            }
            //获取页面最大宽度
            var page_width = Math.max(document.body.scrollWidth, document.body.clientWidth);
            var cutWidth = page_width * 0.0150;
            var page_width = page_width - cutWidth;
            //获取页面最大高度
            var page_height = Math.max(document.body.scrollHeight, document.body.clientHeight) + 450;
            page_height = Math.max(page_height, window.innerHeight - 30);
            //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
            if (defaultSettings.watermark_cols == 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
                defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space));
                defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1));
            }
            //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
            if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
                defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
                defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
            }
            var x;
            var y;
            var str = "";
            for (var i = 0; i < defaultSettings.watermark_rows; i++) {
                y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
                for (var j = 0; j < defaultSettings.watermark_cols; j++) {
                    x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;
                    str += '<div class="watermark" style=" left: '+x+'px; top: '+y+'px;">'
                        //+	   '<p class="watermark_content">${mark_content}</p>'
                        //+      '<p class="watermarker-content-text">SCCS-${mark_content}</p>'

                        + '<p><svg viewBoxs="0 0 20 20" class="svgBox">' +
                        '        <defs>' +
                        '            <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="100%" y2="0%">' +
                        '                 <stop offset="0%" style="stop-color:red;stop-opacity:1" />'+
                        '                 <stop offset="50%" style="stop-color:#747ae8;stop-opacity:1" />'+
                        '                 <stop offset="100%" style="stop-color:#040840;stop-opacity:1" />' +
                        '            </linearGradient>' +
                        '        </defs>' +
                        //'        <text text-anchor="middle" class="gradient-text-three" x="60px" y="20px">SCCS-${mark_content}</text>' +
                        '        <text text-anchor="middle" class="gradient-text-three" x="60px" y="20px">'+this.userId+'</text>' +
                        '    </svg></p>'
                        + '</div>';
                }
            }
            $(".watermark").remove();
            $("body").append(str);
        },
        
    },

};
</script>

<style>
	.watermark{
		webkitTransform:rotate(-20deg);
		MozTransform:rotate(-20deg);
		msTransform:rotate(-20deg);
		OTransform:rotate(-20deg);
		transform: rotate(-20deg);
		position: absolute;
		overflow: hidden;
		z-index: 99999;
		pointer-events: none;
		opacity: 0.4;
		font-size: 14px;
		color: rgb(64, 40, 40);
		text-align: center;
		width: 120px;
		height: 100px;
		display: block;
	}
	
    .ani-backup{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1040;
        background-color: #000;
        opacity: .15;
    }
    
    .ani-box svg {
        -webkit-animation:spin 2s linear infinite;
        -moz-animation:spin 2s linear infinite;
        animation:spin 2s linear infinite;
        width:100px;
        height:100px;
    }

    .ani-box-icon{
        position: fixed;
        top: 100px;
        text-align: center;
        width:100%;
    }

    @-webkit-keyframes spin { 100% { -webkit-transform: rotate(-360deg); } }
    @-moz-keyframes spin { 100% { -moz-transform: rotate(-360deg); } }
    @keyframes spin { 100% { -webkit-transform: rotate(-360deg); transform:rotate(-360deg); } }
</style>
<div id="watermark">
<p> SKP Watermark Test.</p>
</div>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/notice/NoticeList.vue